var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "assignment",
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89200",
    "data-name": "Path 89200",
    d: "M160,80A80,80,0,1,1,80,0,80,80,0,0,1,160,80Zm0,0",
    fill: "#023aff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89201",
    "data-name": "Path 89201",
    d: "M170.627,101.415A69.212,69.212,0,1,1,101.415,32.2,69.211,69.211,0,0,1,170.627,101.415Zm0,0",
    transform: "translate(-21.415 -21.415)",
    fill: "#0a4a6c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89203",
    "data-name": "Path 89203",
    d: "M209.536,208.611H154.4a5.194,5.194,0,0,1-5.194-5.193V129.561a5.194,5.194,0,0,1,5.194-5.194h55.139a5.194,5.194,0,0,1,5.194,5.194v73.856A5.194,5.194,0,0,1,209.536,208.611Zm0,0",
    transform: "translate(-99.219 -82.703)",
    fill: "#d1d3d4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89204",
    "data-name": "Path 89204",
    d: "M209.536,202.411H154.4a5.193,5.193,0,0,1-5.194-5.193V123.362a5.194,5.194,0,0,1,5.194-5.194h55.139a5.194,5.194,0,0,1,5.194,5.194v73.856A5.193,5.193,0,0,1,209.536,202.411Zm0,0",
    transform: "translate(-99.219 -78.581)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89205",
    "data-name": "Path 89205",
    d: "M197.536,196.611H142.4a5.194,5.194,0,0,1-5.194-5.193V117.561a5.194,5.194,0,0,1,5.194-5.194h55.139a5.194,5.194,0,0,1,5.194,5.194v73.856A5.194,5.194,0,0,1,197.536,196.611Zm0,0",
    transform: "translate(-91.239 -74.723)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89206",
    "data-name": "Path 89206",
    d: "M197.536,190.411H142.4a5.193,5.193,0,0,1-5.194-5.193V111.362a5.194,5.194,0,0,1,5.194-5.194h55.139a5.194,5.194,0,0,1,5.194,5.194v73.856A5.193,5.193,0,0,1,197.536,190.411Zm0,0",
    transform: "translate(-91.239 -70.601)",
    fill: "#e6e7e8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89207",
    "data-name": "Path 89207",
    d: "M168.727,99.965H129.993a5.193,5.193,0,0,0-5.193,5.194v73.856a5.193,5.193,0,0,0,5.193,5.194h55.14a5.193,5.193,0,0,0,5.193-5.194v-57.45Zm0,0",
    transform: "translate(-82.992 -66.476)",
    fill: "#d1d3d4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89208",
    "data-name": "Path 89208",
    d: "M166.651,93.766H129.993a5.192,5.192,0,0,0-5.193,5.193v73.856a5.193,5.193,0,0,0,5.193,5.194h55.14a5.193,5.193,0,0,0,5.193-5.194V117.443Zm0,0",
    transform: "translate(-82.992 -62.353)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69814",
    "data-name": "Group 69814",
    transform: "translate(50.059 62.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89209",
    "data-name": "Path 89209",
    d: "M196.375,189.545H151.5a2.077,2.077,0,0,1,0-4.155h44.873a2.077,2.077,0,1,1,0,4.155Zm0,0",
    transform: "translate(-149.426 -185.391)",
    fill: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89210",
    "data-name": "Path 89210",
    d: "M196.375,227.167H151.5a2.077,2.077,0,0,1,0-4.155h44.873a2.077,2.077,0,1,1,0,4.155Zm0,0",
    transform: "translate(-149.426 -210.408)",
    fill: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89211",
    "data-name": "Path 89211",
    d: "M196.375,264.785H151.5a2.078,2.078,0,0,1,0-4.156h44.873a2.078,2.078,0,0,1,0,4.156Zm0,0",
    transform: "translate(-149.426 -235.424)",
    fill: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89212",
    "data-name": "Path 89212",
    d: "M196.375,302.409H151.5a2.077,2.077,0,0,1,0-4.155h44.873a2.077,2.077,0,1,1,0,4.155Zm0,0",
    transform: "translate(-149.426 -260.444)",
    fill: "#d0d2d3"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89213",
    "data-name": "Path 89213",
    d: "M273.4,117.443H254.917a5.194,5.194,0,0,1-5.194-5.194V93.766Zm0,0",
    transform: "translate(-166.064 -62.353)",
    fill: "#bbbdbf"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89214",
    "data-name": "Path 89214",
    d: "M291.474,210.053A21.447,21.447,0,1,0,307,236.11,21.447,21.447,0,0,0,291.474,210.053Zm0,0",
    transform: "translate(-176.06 -139.244)",
    fill: "#5eff5a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89215",
    "data-name": "Path 89215",
    d: "M298.929,223.212A16.978,16.978,0,1,0,311.6,243.605,16.978,16.978,0,0,0,298.929,223.212Zm0,0",
    transform: "translate(-184.926 -148.136)",
    fill: "#4ec44b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89216",
    "data-name": "Path 89216",
    d: "M314.616,247.344h0a3.124,3.124,0,0,0-4.419,0l-9.645,9.645L297.558,254a3.125,3.125,0,1,0-4.418,4.422l5.21,5.2a3.126,3.126,0,0,0,4.418,0l11.848-11.85A3.128,3.128,0,0,0,314.616,247.344Zm0,0",
    transform: "translate(-194.326 -163.872)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSelected);
export default __webpack_public_path__ + "static/media/status-selected.b55b23e3d8fbc7324c3f5d578fa59ebf.svg";
export { ForwardRef as ReactComponent };